import React from "react";
import { AiOutlineSearch } from "react-icons/ai";

function SearchBox({ searchOrderName, setSearchOrderName, searchOrder }) {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      searchOrder();
    }
  };

  return (
    <div className="relative my-4 w-full">
      <AiOutlineSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-[#A3A3A3]" />
      <input
        type="text"
        placeholder="Search with order name"
        className="pl-10 pr-4 py-2.5 rounded w-full text-sm text-black placeholder:text-[#A3A3A3]"
        value={searchOrderName}
        onChange={(e) => setSearchOrderName(e.target.value)}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
}

export default SearchBox;
